import styled, { css } from 'styled-components';

export const Icon = styled.svg`
  fill: none;
  stroke: ${props => props.theme.carvana.blue.primary};
  stroke-width: 3px;
`;

export const CheckboxWrapper = styled.label`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const checked = props => props.checked && css`
  border: 2px solid ${props.theme.carvana.blue.primary};
`;

const focused = props => props.focused && !props.checked && css`
  border: 2px solid ${props.theme.carvana.gray.dark};
`;

export const StyledCheckbox = styled.div<{
  checked?: boolean;
  focused?: boolean;
}>`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  cursor: pointer;
  transition: all 150ms;
  border: 2px solid ${props => props.theme.carvana.gray.light};
  ${checked}
  ${focused}

  &.is-disabled {
    cursor: not-allowed;
    background-color: ${props => props.theme.carvana.gray.light};
  }

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`;

export const CheckboxLabel = styled.label`
  color: black;
  margin-left: 8px;
  padding-top: 2px;
  font-size: 1rem;
  text-align: left;
  cursor: pointer;

  &.is-disabled {
    cursor: not-allowed;
    color: ${props => props.theme.carvana.gray.light};
   }

`;
